// 規約本文は翻訳カタログに入れない。訳文が非公式の規約として出回らないよう、全ロケールで日本語の原文を出す
// 正本は道庁から受領した「マイナポータル利用に伴う追加規約・プライバシーポリシー」（令和8年11月4日制定）
export type TermsParagraph = {
  label?: string;
  text: string;
  quote?: string;
};

export type TermsArticle = {
  heading: string;
  paragraphs: TermsParagraph[];
};

export type TermsDocumentContent = {
  title: string;
  preamble: string;
  articles: TermsArticle[];
  enactment: string;
};

export const HOKKAIDO_MYNA_APPLICATION_TERMS: TermsDocumentContent = {
  title: "マイナポータル利用に伴う追加規約・プライバシーポリシー",
  preamble:
    "この規約・プライバシーポリシーは、どうみんポイントサービスを利用されるユーザーのうち、マイナポータルを通じて取得される情報により世帯主であることの確認を行うことで、どうみんポイントを受け取ろうとするユーザーに適用されます。マイナポータルを利用してどうみんポイントを受領される方は、この規約・プライバシーポリシー（以下「本追加規約」といいます。）に同意のうえ、マイナポータルAPIをご利用ください。",
  articles: [
    {
      heading: "第１条（定義）",
      paragraphs: [
        {
          text: "本追加規約において用いる用語の定義は、「どうみんポイントサービス利用規約」に定めるもののほか、以下に定めるとおりとします。",
        },
        {
          label: "(1)",
          text: "「マイナポータル」とは、デジタル庁が運営するオンラインシステムであり、国民に対して自身の情報の確認やお知らせの通知、行政手続の電子申請等の機能を提供するものをいいます。",
        },
        {
          label: "(2)",
          text: "「自己情報取得API」とは、マイナポータルのサービスの1つである「行政機関等が保有する自己情報を確認できるサービス」と接続し、同サービスを通じて自己情報を確認できるようにするアプリケーション・プログラミング・インタフェース（API）をいいます。",
        },
        {
          label: "(3)",
          text: "「API取得情報」とは、北海道（以下「発行者」といいます。）が自己情報取得APIを通じて取得する、第３条第１項に定める情報をいいます。",
        },
      ],
    },
    {
      heading: "第２条（自己情報取得APIを利用した情報の取得）",
      paragraphs: [
        {
          label: "1.",
          text: "発行者は、ユーザーの事前の同意を得た上で、自己情報取得APIを利用して、ユーザーに関する情報を取得します。ユーザーの同意は、本アプリ（どうみんポイントミニアプリ）上で、所定の方法により取得します。",
        },
        {
          label: "2.",
          text: "発行者が、自己情報取得APIを利用してユーザーの情報を取得することにより、ユーザーは、発行者が送付したハガキを利用することなく、どうみんポイントの受け取りに必要な手続を行うことができます。",
        },
        {
          label: "3.",
          text: "自己情報取得APIを通じた発行者によるユーザー情報の取得には、ユーザーにおいて、マイナポータルにおける利用者登録、マイナンバーカードによる本人確認等、所定の手続を行っていただくことが必要です。所定の手続を履践されないユーザーについては、発行者は、自己情報取得APIを通じて情報を取得することができません。マイナポータルを利用したどうみんポイントの受領を希望されるユーザーは、マイナポータルにおける利用者登録等の所定のお手続をお取りください。",
        },
        {
          label: "4.",
          text: "自己情報取得APIを通じた情報の取得は、ユーザー本人が、ユーザー本人のマイナンバーカードを用いて行うものとします。代理人による手続はできません。",
        },
        {
          label: "5.",
          text: "マイナポータル、住民基本台帳ネットワークシステムその他の関係するシステムの保守点検、障害等により、自己情報取得APIを通じた情報の取得ができない場合があります。この場合は、マイナポータル等のシステムが利用可能になった後に、お手続をお取りください。",
        },
      ],
    },
    {
      heading: "第３条（取得する情報）",
      paragraphs: [
        {
          text: "前条の同意をしたユーザーについて、発行者が自己情報取得APIを通じて取得する情報は、以下のとおりです。",
          quote:
            "自己情報取得APIを通じて取得可能な住民票関係情報のうち、①住民票の発行主体である地方自治体の名称及び②ユーザーの世帯主との続柄（令和８年５月１日時点における情報を取得します。）",
        },
      ],
    },
    {
      heading: "第４条（API取得情報の取扱い）",
      paragraphs: [
        {
          label: "1.",
          text: "発行者は、API取得情報を、以下の利用目的のみに利用します。",
          quote:
            "ユーザーが、令和８年「物価高対策緊急支援事業（道民生活応援ポイント給付事業）」において発行されるどうみんポイントの給付対象者であるか否かを確認するため",
        },
        {
          label: "2.",
          text: "API取得情報には、どうみんポイントサービス利用規約第９条第２項第１号に定める利用目的および同項第２号に定める共同利用に関する定めは適用されません。",
        },
        {
          label: "3.",
          text: "発行者は、法令に基づく場合を除き、API取得情報を第三者に提供しません。",
        },
        {
          label: "4.",
          text: "発行者は、本サービスの提供のため、API取得情報の取得、保存、管理その他の取扱いに関する業務を、ポケットサイン株式会社に委託します。発行者は、委託先において個人情報の保護のために必要な措置が講じられるよう、委託先に対する必要かつ適切な監督を行います。",
        },
      ],
    },
    {
      heading: "第５条（API取得情報の消去）",
      paragraphs: [
        {
          label: "1.",
          text: "ユーザーが第７条に定める窓口に対し、API取得情報の消去を求めたときは、発行者は、遅滞なく、API取得情報を消去します。",
        },
        {
          label: "2.",
          text: "前項によりAPI取得情報が消去された場合でも、既に付与されたどうみんポイントには影響しません。ただし、前条第１項に定める確認が完了する前にAPI取得情報が消去された場合には、発行者は、当該確認を行うことができません。",
        },
      ],
    },
    {
      heading: "第６条（どうみんポイントサービス利用規約との関係）",
      paragraphs: [
        {
          label: "1.",
          text: "本追加規約に定めのない事項は、どうみんポイントサービス利用規約の定めによるものとします。",
        },
        {
          label: "2.",
          text: "本追加規約の定めとどうみんポイントサービス利用規約の定めが異なる場合には、本追加規約の定めが優先して適用されます。",
        },
      ],
    },
    {
      heading: "第７条（お問い合わせ）",
      paragraphs: [
        {
          text: "本追加規約に基づく情報の取得・利用、情報の削除その他本追加規約に関するお問い合わせは、以下の窓口で受け付けます。",
          quote:
            "窓口：北海道　経済部経済企画局経済企画課\nメールアドレス：sogo.keiki1@pref.hokkaido.lg.jp",
        },
      ],
    },
  ],
  enactment: "令和８年１１月４日　制定",
};
